<div class="breadcrumbs" [class.detail-bold]="bold()">
  @for (breadcrumb of breadcrumbs(); track breadcrumb.id) {
    <span class="breadcrumb">
      <span
        [class.clickable]="!!breadcrumb.id"
        [ngClass]="{
          boldTeal: searchTealText() && breadcrumb.bold,
          bold: breadcrumb.bold,
        }"
        (keydown.enter)="navTo(breadcrumb)"
        tabindex="0"
        role="button"
        (click)="navTo(breadcrumb)"
      >
        {{ breadcrumb.text }}
      </span>
      <i nz-icon nzType="double-right" class="svg-icon svg-icon-tiny"></i>
    </span>
  }
</div>
